import { Entity } from '@nx-smartmonkey/shared/domain';

export type TrackSource = `ios` | `android` | `web`; // This is what Capacitor returns with the getPlatform

interface TrackProps {
  driver_id: string;
  vehicle_id: string;
  project_id: string;
  lat: number;
  lng: number;
  source?: TrackSource;
  created_at: Date;
}

export class Track extends Entity<TrackProps> {
  get id(): string {
    return this._id!;
  }
  get driver_id(): string {
    return this.props.driver_id;
  }
  get vehicle_id(): string {
    return this.props.vehicle_id;
  }
  get project_id(): string {
    return this.props.project_id;
  }
  get lat(): number {
    return this.props.lat;
  }
  set lat(lat: number) {
    this.props.lat = lat;
  }
  get lng(): number {
    return this.props.lng;
  }
  set lng(lng: number) {
    this.props.lng = lng;
  }
  get source(): TrackSource | undefined {
    return this.props.source;
  }
  get created_at(): Date {
    return this.props.created_at;
  }
  private constructor(props: TrackProps, id: string) {
    super(props, id);
  }

  static create(props: TrackProps, id: string) {
    return new Track(props, id);
  }
}
